import { useState, useEffect } from 'react';

/**
 * Hook for clock time and display time formatting in the driver's base timezone.
 */
export function useTimeDisplay(driverInfo) {
  const [useBaseTime, setUseBaseTime] = useState(true);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatDisplayTime = (isoString, includeDate = false) => {
    if (!isoString) return '--:--';
    const date = new Date(isoString);

    if (useBaseTime && driverInfo?.base_timezone) {
      const options = { hour: '2-digit', minute: '2-digit', hour12: true, timeZone: driverInfo.base_timezone };
      if (includeDate) {
        return date.toLocaleString('en-AU', { ...options, weekday: 'short', day: '2-digit', month: 'short' });
      }
      return date.toLocaleTimeString('en-AU', options);
    }
    const options = { hour: '2-digit', minute: '2-digit', hour12: true };
    if (includeDate) {
      return date.toLocaleString('en-AU', { ...options, weekday: 'short', day: '2-digit', month: 'short' });
    }
    return date.toLocaleTimeString('en-AU', options);
  };

  const getClockTime = () => {
    if (useBaseTime && driverInfo?.base_timezone) {
      return currentTime.toLocaleTimeString('en-AU', {
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true, timeZone: driverInfo.base_timezone
      });
    }
    return currentTime.toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
  };

  const getClockDate = () => {
    if (useBaseTime && driverInfo?.base_timezone) {
      return currentTime.toLocaleDateString('en-AU', {
        weekday: 'short', day: '2-digit', month: 'short', timeZone: driverInfo.base_timezone
      });
    }
    return currentTime.toLocaleDateString('en-AU', { weekday: 'short', day: '2-digit', month: 'short' });
  };

  return { useBaseTime, setUseBaseTime, formatDisplayTime, getClockTime, getClockDate };
}
